import { ChangeDetectionStrategy, Component, Signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import Userback from "@userback/widget";

import { BarraLateralComponent } from '@app/shared/components/barra-lateral/barra-lateral.component';
import { BarraSuperiorComponent } from '@app/shared/components/barra-superior/barra-superior.component';
import { EnvironmentRibbonComponent } from '@app/shared/components/environment-ribbon/environment-ribbon.component';

import { LigaService } from '@app/services/liga/ligas.service';
import { Liga } from '@app/models/liga.model';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    BarraLateralComponent,
    BarraSuperiorComponent,
    EnvironmentRibbonComponent,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainComponent {

  private readonly _ligaService: LigaService = inject(LigaService);
  public ligaActual: Signal<Liga | null> = this._ligaService.ligaActual;

  constructor() {
    console.log('App Version: 1.0.1-build-fix');
    Userback("A-PLzQhvINiyCui3Og9QXCO83XP")
      .then(() => console.log("Userback successfully initialized"))
      .catch(() => {});
  }
}
